import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore, useCartStore } from '../../store';

const Navbar = () => {
  const { user, logout } = useAuthStore();
  const { getCount } = useCartStore();
  const navigate = useNavigate();
  const cartCount = getCount();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
    setMenuOpen(false);
  };

  const close = () => setMenuOpen(false);

  return (
    <nav style={styles.nav}>
      <div className="container flex-center" style={{ justifyContent: 'space-between', height: '100%' }}>
        {/* Logo */}
        <Link to="/" style={styles.logo} onClick={close}>
          <img src="/logo.png" alt="SchoolKit2go" className="logo-img" />
        </Link>

        {/* Desktop Nav Links */}
        <div className="flex-center gap-4 hide-mobile">
          <Link to="/" style={styles.link} onMouseEnter={e => e.currentTarget.style.color = '#2563eb'} onMouseLeave={e => e.currentTarget.style.color = '#374151'}>Home</Link>
          <Link to="/products" style={styles.link} onMouseEnter={e => e.currentTarget.style.color = '#2563eb'} onMouseLeave={e => e.currentTarget.style.color = '#374151'}>Build Your Kit</Link>
          <Link to="/kits" style={styles.link} onMouseEnter={e => e.currentTarget.style.color = '#2563eb'} onMouseLeave={e => e.currentTarget.style.color = '#374151'}>School Kits</Link>
          {user?.role === 'admin' && (
            <Link to="/admin" style={{ ...styles.link, color: '#f59e0b' }} onMouseEnter={e => e.currentTarget.style.color = '#d97706'} onMouseLeave={e => e.currentTarget.style.color = '#f59e0b'}>Admin</Link>
          )}
        </div>

        {/* Right */}
        <div className="flex-center gap-2">
          <Link to="/track-order" className="hide-mobile" style={styles.trackBtn} title="Track Order">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="1" y="3" width="15" height="13" rx="2"/>
              <path d="M16 8h4l3 5v4h-7V8z"/>
              <circle cx="5.5" cy="18.5" r="2.5"/>
              <circle cx="18.5" cy="18.5" r="2.5"/>
            </svg>
          </Link>
          <Link to="/cart" style={styles.cartBtn} onClick={close}>
            🛒
            {cartCount > 0 && <span style={styles.badge}>{cartCount}</span>}
          </Link>

          {user && (
            <div className="flex-center gap-3 hide-mobile" style={{ marginLeft: '0.5rem', paddingLeft: '1rem', borderLeft: '1px solid #e5e7eb' }}>
              <Link to="/my-orders" style={{ ...styles.link, fontSize: '0.85rem' }} onMouseEnter={e => e.currentTarget.style.color = '#2563eb'} onMouseLeave={e => e.currentTarget.style.color = '#374151'}>📦 My Orders</Link>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem', background: '#f3f4f6', padding: '0.3rem 0.4rem 0.3rem 0.8rem', borderRadius: 999 }}>
                <span style={{ fontSize: '0.85rem', color: '#4b5563', fontWeight: 600 }}>{user.name?.split(' ')[0]}</span>
                <button className="btn btn-sm" style={{ background: '#fff', color: '#ef4444', border: '1px solid #e5e7eb', padding: '0.2rem 0.8rem', borderRadius: 999, fontSize: '0.75rem' }} onClick={handleLogout} onMouseEnter={e => e.currentTarget.style.background = '#fee2e2'} onMouseLeave={e => e.currentTarget.style.background = '#fff'}>Logout</button>
              </div>
            </div>
          )}

          {/* Hamburger */}
          <button
            onClick={() => setMenuOpen(o => !o)}
            style={styles.hamburger}
            aria-label="Toggle menu"
            className="show-mobile"
          >
            {menuOpen ? '✕' : '☰'}
          </button>
        </div>
      </div>

      {/* Mobile dropdown */}
      {menuOpen && (
        <div style={styles.mobileMenu}>
          <Link to="/" style={styles.mobileLink} onClick={close}>🏠 Home</Link>
          <Link to="/products" style={styles.mobileLink} onClick={close}>🛍️ Build Your Kit</Link>
          <Link to="/kits" style={styles.mobileLink} onClick={close}>🎒 School Kits</Link>
          <Link to="/track-order" style={styles.mobileLink} onClick={close}>🚚 Track Order</Link>
          <Link to="/faqs" style={styles.mobileLink} onClick={close}>❓ FAQs</Link>
          <Link to="/contact" style={styles.mobileLink} onClick={close}>📬 Contact Us</Link>
          {user?.role === 'admin' && (
            <Link to="/admin" style={{ ...styles.mobileLink, color: '#f59e0b' }} onClick={close}>⚙️ Admin</Link>
          )}
          <div style={{ borderTop: '1px solid #e5e7eb', marginTop: '0.5rem', paddingTop: '0.75rem' }}>
            {user && (
              <>
                <div style={{ fontSize: '0.8rem', color: '#6b7280', padding: '0 1rem 0.5rem' }}>Hi, {user.name?.split(' ')[0]}</div>
                <Link to="/my-orders" style={styles.mobileLink} onClick={close}>📦 My Orders</Link>
                <button style={{ ...styles.mobileLink, background: 'none', border: 'none', cursor: 'pointer', width: '100%', textAlign: 'left' }} onClick={handleLogout}>🚪 Logout</button>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};

const styles = {
  nav: {
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    borderBottom: '1px solid rgba(229, 231, 235, 0.5)',
    height: 72,
    position: 'sticky',
    top: 0,
    zIndex: 100,
    boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
    transition: 'all 0.3s ease'
  },
  logo: { display: 'flex', alignItems: 'center', gap: '0.4rem', transform: 'scale(1.05)', transformOrigin: 'left center' },
  link: { fontSize: '0.9rem', fontWeight: 600, color: '#374151', padding: '0.4rem 0.5rem', borderRadius: 6, transition: 'color 0.2s', textDecoration: 'none' },
  trackBtn: { display: 'flex', alignItems: 'center', color: '#374151', padding: '0.3rem', borderRadius: 6 },
  cartBtn: { position: 'relative', fontSize: '1.25rem', padding: '0.2rem' },
  badge: {
    position: 'absolute', top: -6, right: -6,
    background: '#ef4444', color: '#fff',
    borderRadius: '50%', width: 17, height: 17,
    fontSize: '0.6rem', fontWeight: 700,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  hamburger: {
    background: 'none', border: 'none', cursor: 'pointer',
    fontSize: '1.4rem', color: '#374151', padding: '0.25rem 0.4rem',
    lineHeight: 1,
  },
  mobileMenu: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    background: '#fff',
    borderTop: '1px solid #e5e7eb',
    padding: '0.75rem 0',
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
    zIndex: 90,
  },
  mobileLink: {
    display: 'block',
    padding: '0.65rem 1.25rem',
    fontSize: '0.88rem',
    fontWeight: 600,
    color: '#374151',
    textDecoration: 'none',
  },
};

export default Navbar;
